import { SharedAppState } from 'shared/state/store.shared';

export const selectSiteId = (state: SharedAppState) => state.profile.active && state.profile.active.siteId;
